import { render, staticRenderFns } from "./EditServiceRecord.vue?vue&type=template&id=0d31d4d3&scoped=true"
import script from "./EditServiceRecord.vue?vue&type=script&lang=js"
export * from "./EditServiceRecord.vue?vue&type=script&lang=js"
import style0 from "./EditServiceRecord.vue?vue&type=style&index=0&id=0d31d4d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d31d4d3",
  null
  
)

export default component.exports